import { Stack, useMediaQuery } from '@mui/material'
import { useCompanyInfo } from 'hooks/company'
import Information from './Information'
import TopPC from './TopPC'
import TopMobile from './TopMobile'


const Top = () => {
    const upmd = useMediaQuery((theme) => theme.breakpoints.up('md'))
    const { data } = useCompanyInfo()

    return (
        <Stack>
            {data && !data.ツナグープラス &&
            <Information />
            }
            {upmd ?
            <TopPC />
            :
            <TopMobile />
            }
        </Stack>
    )
}

export default Top
